import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import { Redirect } from 'react-router-dom';

import styles from './styles';
import Main from './components/Main';
import Header from './components/Header';
import ActionsRow from './components/ActionsRow';
import FullWidthPageContainer from '../FullWidthPageContainer';
import { selectRegistrationInfo } from '../../store/selectors';
import { USER_ROLE_TYPES } from '../../constants';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  registrationInfo: PropTypes.shape({
    name: PropTypes.string,
    personalEmail: PropTypes.string,
    buildingLicNo: PropTypes.string,
    legal: PropTypes.bool,
  }).isRequired,
};

export const RegistrationContainer = props => {
  const { classes, registrationInfo } = props;

  if (
    !registrationInfo['custom:firstName'] ||
    !registrationInfo['custom:surname'] ||
    !registrationInfo['custom:personalEmail'] ||
    (registrationInfo['custom:roleType'] === USER_ROLE_TYPES.BUILDER.code &&
      !registrationInfo['custom:buildingLicNo']) ||
    !registrationInfo.legal
  ) {
    return <Redirect to="/" />;
  }

  return (
    <FullWidthPageContainer>
      <div className={classes.root}>
        <Header />
        <Main />
        <ActionsRow />
      </div>
    </FullWidthPageContainer>
  );
};

RegistrationContainer.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  registrationInfo: selectRegistrationInfo(),
});

export default withStyles(styles)(
  connect(mapStateToProps)(RegistrationContainer),
);
